// Ids соответствуют enum AdItemContentOpenTypeValue на бэкенде:
// 0 ПОИСК ТОВАРА, 1 ПРЕЗЕНТАЦИЯ, 2 ВИДЕО, 3 ИЗОБРАЖЕНИЕ, 4 ССЫЛКА.
// Порядок — приоритет автоматического действия по клику на баннер:
// разворачивающийся баннер важнее прямого перехода к SKU (переход выполняется
// после просмотра большого баннера), внешняя ссылка важнее поиска товара.
const OPEN_TYPE_PRIORITY = [3, 1, 2, 4, 0];

export function resolvePrimaryOpen(adItemContentOpens) {
    if (adItemContentOpens == null || adItemContentOpens.length === 0) {
        return null;
    }

    for (const typeId of OPEN_TYPE_PRIORITY) {
        const open = adItemContentOpens.find(
            (x) => x.adItemContentOpenTypeId === typeId
        );
        if (open != null) {
            return open;
        }
    }

    return null;
}
